module.exports = __webpack_public_path__ + "static/media/tuliphedge_square_logo.c9f4a5dd.png";